/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { clog, getEncriptedLoginData } from "../lib/utils";

function PaymentSuccess() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);
  const [verificationStatus, setVerificationStatus] = useState("verifying"); // 'verifying' | 'success' | 'error'
  const [errorMessage, setErrorMessage] = useState("");
  const timerRef = useRef(null);

  // Call the payment success API first, only start countdown after it succeeds
  useEffect(() => {
    const callPaymentSuccessApi = async () => {
      try {
        let response = await axios({
          url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/user/payment/success`,
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            jwt_token: localStorage.getItem("login_token"),
          },
          data: {
            session_id: localStorage.getItem("stripe_vision_session_id"),
          },
        });
        if (!response.data.error) {
          // Handle success - update localStorage BEFORE allowing navigation
          localStorage.removeItem("stripe_vision_session_id");
          let loginData = JSON.parse(localStorage.getItem("login_data"));
          loginData = {
            ...loginData,
            resp_user: {
              ...loginData.resp_user,
              plan_id: response.data.plan_id,
              subscription_id: response.data.subscription_id,
              bal_credits: response.data.bal_credits,
              credit_limit: response.data.credit_limit || 100,
              subscription: response.data.subscription,
            },
            user_menus: response.data.user_menus,
          };
          // Fetch fresh workspace data from GraphQL API to update all workspace-related localStorage
          try {
            const token = localStorage.getItem("login_token");
            const wsResponse = await axios.post(
              `${process.env.REACT_APP_BASE_SIGNIN_URL}/graphql`,
              {
                query: `
                  query{
                    getUserworkspaces{
                      user_id,
                      workspace_id,
                      user_type_id,
                      workspace{
                          workspace_id,
                          workspace_name,
                          uniq_id,
                          user_id,
                          workspace_avtar,
                          workspace_icon,
                      },
                      user{
                          user_id,
                          first_name,
                          last_name,
                          email,
                          plan_id
                      },
                      user_menus{
                          person_level_id,
                          company_level_id,
                          script,
                          user_activity,
                          email_outreach,
                          sales,
                          knowledge_base,
                          monthly_calendar,
                          ai_employee,
                          marketing,
                          social,
                          notification,
                          specific_page_tracking,
                          exclusion_filter
                      }
                    }
                  }
                `,
              },
              {
                headers: { jwt_token: token },
              }
            );

            const freshWorkspaces =
              wsResponse?.data?.data?.getUserworkspaces || [];
            // Update workspaces_list in localStorage
            localStorage.setItem(
              "workspaces_list",
              JSON.stringify(freshWorkspaces)
            );
            // Update workspacess in login_data
            loginData.workspacess = freshWorkspaces;

            // Update selected_workspace with fresh data
            const currentSelectedWs = JSON.parse(
              localStorage.getItem("selected_workspace") || "{}"
            );
            if (currentSelectedWs?.workspace_id) {
              const updatedWs = freshWorkspaces.find(
                (ws) => ws?.workspace_id === currentSelectedWs?.workspace_id
              );
              if (updatedWs) {
                localStorage.setItem(
                  "selected_workspace",
                  JSON.stringify(updatedWs)
                );
              }
            }
          } catch (wsError) {
            clog("Error refreshing workspace data after payment:", wsError);
            // Non-critical — login_data already has the updated user_menus from the payment API
          }

          localStorage.setItem(
            "login_data",
            JSON.stringify(getEncriptedLoginData(loginData))
          );

          // Now that localStorage is updated, show success and start countdown
          setVerificationStatus("success");
        } else {
          setVerificationStatus("error");
          setErrorMessage(
            response?.data?.message || "Payment verification failed"
          );
        }
      } catch (error) {
        clog(error);
        setVerificationStatus("error");
        setErrorMessage(
          error?.response?.data?.message ||
            "Payment verification failed. Please contact support if the issue persists."
        );
      }
    };
    callPaymentSuccessApi();
  }, []);

  // Start countdown only after verification succeeds
  useEffect(() => {
    if (verificationStatus !== "success") return;

    timerRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          localStorage.removeItem("price_id");
          localStorage.removeItem("visonsignupplan");
          navigate("/script");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [verificationStatus, navigate]);

  const handleGoToDashboard = () => {
    localStorage.removeItem("price_id");
    localStorage.removeItem("visonsignupplan");
    navigate("/script");
  };

  const handleRetry = () => {
    setVerificationStatus("verifying");
    setErrorMessage("");
    // Re-trigger the API call by remounting
    window.location.reload();
  };

  return (
    <>
      <div className="h-screen">
        <img
          className="loginfram w-full h-full absolute z-[-10]"
          src={`${window.location.origin}/images/frame.png`}
          alt="frame png"
        />
        <div className="flex flex-wrap -mx-6l h-screen">
          <div className="w-full md:w-1/2 px-[80px] flex items-center justify-center">
            <div className="w-[560px]">
              <img
                className="w-full"
                src={`${window.location.origin}/images/signin-left.png`}
                alt="signin left png"
              />
            </div>
          </div>
          <div className="w-full md:w-1/2 px-[80px] flex items-center justify-center">
            <div className="w-full max-w-[500px]">
              <div
                className="flex justify-center cursor-pointer mb-6"
                onClick={() => window.open(process.env.REACT_APP_LANDING_URL)}
              >
                <img
                  src={`${window.location.origin}/images/VisonWithOReplaced.png`}
                  width={150}
                  height={50}
                  alt="vision logo png"
                />
              </div>

              {/* Verifying State */}
              {verificationStatus === "verifying" && (
                <>
                  <div className="mb-6 flex justify-center">
                    <div className="w-20 h-20 bg-gradient-to-r from-[#1A71A7] to-[#9D3784] rounded-full flex items-center justify-center">
                      <svg
                        className="w-10 h-10 text-white animate-spin"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        />
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        />
                      </svg>
                    </div>
                  </div>
                  <h5 className="font-extrabold text-[40px] text-center mb-4">
                    Verifying Payment
                  </h5>
                  <p className="text-center text-[20px] font-semibold mb-8">
                    Please wait while we verify your payment and activate your
                    subscription...
                  </p>
                  <div className="bg-[#FAFBFC] border border-[#E9EBF0] rounded-[20px] p-6 mb-6 text-center">
                    <p className="text-[18px] font-semibold text-gray-600">
                      This may take a few moments
                    </p>
                    <div className="mt-3 flex justify-center gap-1">
                      <div
                        className="w-2.5 h-2.5 rounded-full bg-gradient-to-r from-[#1A71A7] to-[#9D3784] animate-bounce"
                        style={{ animationDelay: "0ms" }}
                      ></div>
                      <div
                        className="w-2.5 h-2.5 rounded-full bg-gradient-to-r from-[#1A71A7] to-[#9D3784] animate-bounce"
                        style={{ animationDelay: "150ms" }}
                      ></div>
                      <div
                        className="w-2.5 h-2.5 rounded-full bg-gradient-to-r from-[#1A71A7] to-[#9D3784] animate-bounce"
                        style={{ animationDelay: "300ms" }}
                      ></div>
                    </div>
                  </div>
                </>
              )}

              {/* Success State */}
              {verificationStatus === "success" && (
                <>
                  <div className="mb-6 flex justify-center">
                    <div className="w-20 h-20 bg-gradient-to-r from-[#1aa75e] to-[#379d76] rounded-full flex items-center justify-center">
                      <svg
                        className="w-10 h-10 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={3}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                  </div>
                  <h5 className="font-extrabold text-[40px] text-center mb-4">
                    Payment Successful!
                  </h5>
                  <p className="text-center text-[20px] font-semibold mb-8">
                    Thank you for your payment. Your subscription has been
                    activated successfully.
                  </p>
                  <div className="bg-[#FAFBFC] border border-[#E9EBF0] rounded-[20px] p-6 mb-6 text-center">
                    <p className="text-[18px] font-semibold mb-2">
                      Redirecting to your dashboard in
                    </p>
                    <div className="text-[40px] font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-[#1A71A7] to-[#9D3784]">
                      {countdown} second{countdown !== 1 ? "s" : ""}
                    </div>
                  </div>
                  <button
                    onClick={handleGoToDashboard}
                    className="w-full mt-2 justify-center py-2 px-[20px] rounded-[20px] font-semibold bg-gradient-to-r from-[#1A71A7] to-[#9D3784] text-white hover:from-[#9D3784] hover:to-[#1A71A7] text-[20px] transition duration-700"
                  >
                    Go to Dashboard Now
                  </button>
                </>
              )}

              {/* Error State */}
              {verificationStatus === "error" && (
                <>
                  <div className="mb-6 flex justify-center">
                    <div className="w-20 h-20 bg-gradient-to-r from-[#DF3939] to-[#c0392b] rounded-full flex items-center justify-center">
                      <svg
                        className="w-10 h-10 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={3}
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </div>
                  </div>
                  <h5 className="font-extrabold text-[40px] text-center mb-4">
                    Verification Issue
                  </h5>
                  <p className="text-center text-[20px] font-semibold mb-8">
                    {errorMessage}
                  </p>
                  <div className="flex flex-col gap-3">
                    <button
                      onClick={handleRetry}
                      className="w-full justify-center py-2 px-[20px] rounded-[20px] font-semibold bg-gradient-to-r from-[#1A71A7] to-[#9D3784] text-white hover:from-[#9D3784] hover:to-[#1A71A7] text-[20px] transition duration-700"
                    >
                      Retry Verification
                    </button>
                    <button
                      onClick={handleGoToDashboard}
                      className="w-full justify-center py-2 px-[20px] rounded-[20px] font-semibold border-2 border-gray-300 text-gray-600 hover:bg-gray-50 text-[20px] transition duration-700"
                    >
                      Go to Dashboard
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PaymentSuccess;
